import { px } from 'framer-motion';
import { ReactElement, ReactNode } from 'react';

// Define the type for the context
export type ViewportContextType = boolean;

export type ViewportComponentType = 'ViewportSmall' | 'ViewportMedium' | 'ViewportLarge' | 'ViewportExtraLarge';

// Define the types for the props
export interface ViewportComponentProps {
  children: ReactNode;
  type: ViewportComponentType;
}

export interface ViewportProps {
  children: ReactElement | ReactElement<ViewportComponentProps>[];
}

export const VIEWPORT_SIZES = {
  sm: 'ViewportSmall',
  md: 'ViewportMedium',
  lg: 'ViewportLarge',
  xl: 'ViewportExtraLarge',
};

//device size mapping
/* 
Mobile - < 768px
Tablet - 768px <=  && < 1280px
Desktop - 1580 <= && < 1680px
Large Desktop - >= 1680px 
*/
